(ns practitest.frontend.forms3.instance
  (:require
    [practitest.frontend.common-entities.events :as common-events]
    [practitest.frontend.common-entities.metadata :as metadata]
    [practitest.frontend.common.dom :as dom]
    [practitest.frontend.common.format-utils :as fu]
    [practitest.frontend.common.i18n :refer [format-translation get-translation]]
    [practitest.frontend.common.mixpanel :as mixpanel]
    [practitest.frontend.common.permissions :as permissions]
    [practitest.frontend.common.re-frame :refer [partial-dispatch partial-subscribe]]
    [practitest.frontend.components.grid.localstorage :as grid-storage]
    [practitest.frontend.components.grid.sessionstorage :as grid-session-storage]
    [practitest.frontend.components.grid.subs :as grid.subs]
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.components2.buttons :as buttons]
    [practitest.frontend.components2.entity-form.forms :as forms]
    [practitest.frontend.components2.grid :as grid]
    [practitest.frontend.components2.grid.common :as gc]
    [practitest.frontend.components2.grid.fields :refer [transform-fields]]
    [practitest.frontend.components2.grid.fields :as gf]
    [practitest.frontend.components2.grid.row-menu :as row-menu]
    [practitest.frontend.components2.test-type :as test-type]
    [practitest.frontend.components2.traceability :as traceability]
    [practitest.frontend.events :as events]
    [practitest.frontend.forms3.entity-form :as f3.entity-form]
    [practitest.frontend.forms3.entity-form.collab-ws :as collab-ws]
    [practitest.frontend.forms3.entity-form.footer :as footer]
    [practitest.frontend.forms3.entity-form.forms :as f3.forms]
    [practitest.frontend.forms3.entity-form.traceability :as traceability3]
    [practitest.frontend.forms3.entity-form.utils :refer [track!]]
    [practitest.frontend.forms3.instance.events :as instance-events]
    [practitest.frontend.forms3.instance.rewind-run :as rewind-run]
    [practitest.frontend.forms3.instance.step-parameters :as step-parameters]
    [practitest.frontend.routing.backend-routes :as broutes]
    [practitest.frontend.routing.router :as router]
    [practitest.frontend.subs :as subs]
    [re-frame.core :as re-frame]
    [reagent.core :as reagent]))

(def ^:private entity-type :instance)
(def metadata (get metadata/entities-metadata entity-type))
(def ^:private form-id (get metadata :form-id))
(def edit-permission (get metadata :edit-permissions))
(def delete-permission (get metadata :delete-permissions))
(def run-permission "runs")

(defn instance-menu []
  (let [instance (:current @(re-frame/subscribe [::subs/entity entity-type]))
        {:keys [id]} instance]
    [{:id (str "instance-" id "-delete")
      :text (get-translation "generic.button.delete" "Delete")
      :icon [icons/mux-trash]
      :disabled? (not (permissions/has-permission? delete-permission))
      :on-click (fn [e]
                  (mixpanel/track "Form Actions" {"Action" "Delete Instance"})
                  (dom/prevent-default e)
                  (track! "Delete entity" entity-type)
                  (when (js/confirm (get-translation "entity.confirm.action-delete" "Are you sure? This Operation cannot be undone."))
                    (re-frame/dispatch [::instance-events/delete-instance id])))}

     {:text (get-translation "instance.button.go-to-test" "Go to Test")
      :on-click (fn [e]
                  (mixpanel/track "Form Actions" {"Action" "Go to Test"}))
      :href (broutes/get-url-view "qtest_designs#edit" {:id (:qtest_design_id instance)})
      :icon [icons/mux-test-library]}]))

(gc/register-field-type!
  ::run-date
  gf/simple-header
  (fn [{:keys [field]} row]
    (get row field))
  (fn [{:keys [field]} row]
    (let [value (get row field)
          formatter-value (fu/formatted-date-time value)]
      [:a {:href (broutes/get-url-view "qtest_runs#edit" {:id (get row :id)})}
       formatter-value]))
  gc/default-search-fn
  gf/compare-date-time)

(gc/register-field-type!
  ::run-type
  gf/simple-header
  (fn [{:keys [field]} row]
    (get row field))
  (fn [{:keys [field]} row]
    (let [value (get row field)]
      (case value
        "ManualRun"
        "Manual"

        ;else
        value)))
  gc/default-search-fn
  gc/default-compare-fn)

(defmethod grid.subs/columns :instance-linked-runs
  [[_current-project entity-fields fields users groups folders test-case-versioning-enabled?] [_ [_entity _]]]
  (concat
    [{:type ::run-date,
      :field :run_date,
      :default-width 140,
      :header "Run Date"}
     {:type ::run-type
      :field :run_type
      :default-width 80,
      :header "Run Type"}
     {:type :text,
      :field :name,
      :default-width 250,
      :autofilter? true,
      :header "Test Name"}
     {:type :run_status,
      :field :status,
      :default-width 100,
      :autofilter? true,
      :header "Run Status"}
     {:type :text,
      :field :tester_user_name
      :default-width 150,
      :header "Tester"}]
    (when test-case-versioning-enabled?
      [{:type          :version_label,
        :field         :version_label
        :default-width 150,
        :header        "Version Label"}])
    (transform-fields []
                      (dissoc (:run entity-fields))
                      fields users groups folders)))

(re-frame/reg-sub
  ::linked-issues
  :<- [::traceability3/traceability]
  (fn [{:keys [issues]}]
    (group-by :qtest_run_id issues)))

(re-frame/reg-sub
  ::expandable-row?
  :<- [::linked-issues]
  (fn [issues-map [_ {:keys [id]}]]
    (contains? issues-map id)))

(re-frame/reg-sub
  ::expanded-row?
  (fn [db [_ row]]
    (contains? (get-in db [:form-states2 form-id :expanded-runs])
               (:id row))))

(defn- expandable-row-linked-issues [grid-props idx row]
  (when @(re-frame/subscribe [::expanded-row? row])
    (let [run-id (:id row)
          even-row? (grid/apply-even-class? idx)
          columns-count (count (:shown-columns grid-props))
          issues (get @(re-frame/subscribe [::linked-issues]) run-id)]
      (into
        [:<>]
        (map-indexed
          (fn [idx issue]
            [:tr {:class (dom/classes-pairs-v :grid-row-even even-row?)
                  :key (:id issue)}
             [:td.hierarchical-child-cell]
             [:td.linked-issue-cell {:col-span (max 1 columns-count)}
              [:span.icon [icons/mux-issue]]
              [:a {:href (broutes/get-url-view "issues#show" {:id (:id issue)})}
               [:span.name "Issue " (:display_id issue) " - " (:name issue)]]
              [:span (str "(" (:issue_status issue) ")")]]])
          issues)))))

(defn linked-runs-section [form-props]
  (let [run-columns @(re-frame/subscribe [::grid.subs/columns [:instance :instance-linked-runs]])
        has-delete-permission? (permissions/has-permission? delete-permission)
        post-columns [{:header        ""
                       :field         :actions
                       :default-width 50
                       :width         50
                       :type          :custom
                       :text-align    :center
                       :resizable?    false
                       :sortable?     false
                       :systemcol?    true
                       :class         ["action-menu"]
                       :cell-fn       (fn [_ row]
                                        [row-menu/row-menu row (not has-delete-permission?)
                                         [{:label (get-translation "generic.button.delete" "Delete")
                                           :icon icons/mux-trash
                                           :disabled? (not has-delete-permission?)
                                           :on-click (fn []
                                                       (mixpanel/track "Grid Actions" {"Action" "Delete Run"})
                                                       (re-frame/dispatch [::instance-events/delete-run (:id row)]))
                                           :confirmation {:title (get-translation "instance.delete-run.title"
                                                                                  "Delete Run?")
                                                          :body (format-translation
                                                                  (get-translation "entity.confirm.delete.body"
                                                                                   "\"%{object-name}\" will be deleted permanently.")
                                                                  :object-name (fu/truncate-text (:name row) 30))
                                                          :yes-label (get-translation "generic.button.delete"
                                                                                      "Delete")
                                                          :no-label (get-translation "generic.button.cancel"
                                                                                     "Cancel")}}

                                          (when (rewind-run/show-rewind-run?)
                                            (rewind-run/rewind-run-menu-item row))]])}]
        fields @(re-frame/subscribe [::subs/fields])
        data @(re-frame/subscribe [::traceability3/traceability])
        sorted-runs-data (vec (sort-by :run-date > (:linked_runs data)))
        current-project-id @(re-frame/subscribe [::subs/current-project-id])
        table-id (str current-project-id "-" "instance-testset-runs-table")
        grid-props (merge {:fields fields
                           :columns run-columns
                           :post-columns post-columns
                           :data sorted-runs-data
                           :resizable? true
                           :per-page-save (reagent/partial grid-storage/save-per-page table-id)
                           :per-page-load (reagent/partial grid-storage/load-per-page table-id)
                           :autofilters-save (reagent/partial grid-session-storage/save-autofilters table-id)
                           :autofilters-load (reagent/partial grid-session-storage/load-autofilters table-id)
                           :sort-order-save (reagent/partial grid-session-storage/save-sort-order table-id)
                           :sort-order-load (reagent/partial grid-session-storage/load-sort-order table-id)
                           :columns-widths-save (reagent/partial grid-storage/save-column-sizes table-id)
                           :columns-widths-load (reagent/partial grid-storage/load-column-sizes table-id)
                           :full-data? true
                           :class "traceability-tab-grid"
                           :empty-table-message [:div.empty-section-grid [:span (get-translation "entity.traceability.no_linked" "No Items Linked")]]
                           :options {:selectable? true}
                           ;; expandable linked issues
                           :expandable-row? (partial-subscribe [::expandable-row?])
                           :expanded-row? (partial-subscribe [::expanded-row?])
                           :expandable-row-component expandable-row-linked-issues
                           :on-expand-row-click (fn [e row]
                                                  (re-frame/dispatch [::instance-events/toggle-expand-row row]))})]
    [traceability3/traceability-section
     (merge form-props
            {:save-collapsed (reagent/partial traceability3/save-collapsed table-id)
             :load-collapsed (reagent/partial traceability3/load-collapsed table-id)})
     :run :runs sorted-runs-data grid-props]))

(defn- form-layout-instance
  [xbot? entity-fields]
  (let [nil-or-unavailable? (fn [field]
                              (or (nil? field)
                                  (not (contains? entity-fields field))))

        initial-layout {:title {:fields [{:field :name}]}
                        (:step-parameters f3.entity-form/sections-keys) {}}

        existing-fields (set (f3.forms/flatten-layout initial-layout))
        xbot-only-fields #{:client_id}
        to-remove? (fn [field]
                     (or (nil-or-unavailable? field)
                         (and (not xbot?) (contains? xbot-only-fields field))
                         (contains? existing-fields field)))

        filtered-entity-fields (f3.entity-form/filter-entity-fields entity-fields to-remove?)
        filtered-entity-fields-flat (vec (keys filtered-entity-fields))
        entity-sections @(re-frame/subscribe [::subs/entity-sections entity-type])

        update-main-sections (if (some? entity-sections)
                               #(f3.entity-form/update-layout % entity-sections filtered-entity-fields)
                               #(f3.entity-form/update-layout % (:general-info f3.entity-form/sections-keys) filtered-entity-fields-flat "general_info" entity-fields))

        layout (-> initial-layout
                   (update-main-sections)
                   (f3.entity-form/update-layout (:test-versioning f3.entity-form/sections-keys) [] "test_versioning" entity-fields))]
    layout))

(defmethod f3.forms/build-entity-form-layout form-id
  [_ _ _ entity-fields entity]
  (form-layout-instance (test-type/is-xbot? (:test_type (:qtest_design entity))) entity-fields))

(defn build-edit-controller []
  {:start (fn [params]
            (let [{:keys [instance-id testset-id project-id]} (:path params)]
              (re-frame/dispatch [::forms/reset-form-state false entity-type form-id []])
              (re-frame/dispatch [::events/set-current-entity-type entity-type])
              (re-frame/dispatch [::subs/set-current-entity-id
                                  entity-type
                                  instance-id])

              (let [fetch-options {:form-id form-id
                                   :entity-type entity-type
                                   :entity-id instance-id
                                   :project-id project-id
                                   :new? false
                                   :testset-in-url? (some? testset-id)
                                   :got-entity-data [::instance-events/got-instance]}]
                (re-frame/dispatch [::f3.entity-form/fetch-fields fetch-options])
                (re-frame/dispatch [::f3.entity-form/fetch-entity fetch-options])
                (re-frame/dispatch [::collab-ws/subscribe-to-form-ws [(:plural-key metadata)]]))

              ;; Fetch testset as well
              (when testset-id
                (let [fetch-options {:form-id :testset
                                     :entity-type :testset
                                     :entity-id testset-id
                                     :project-id project-id
                                     :new? false}]
                  (re-frame/dispatch [::f3.entity-form/fetch-entity fetch-options])))

              (re-frame/dispatch [::events/fetch-attachments])
              (re-frame/dispatch [::events/fetch-history])
              (re-frame/dispatch [::common-events/trigger-online-request])
              (mixpanel/track "Grid Actions" {"Action" "Edit Instance"})))
   :stop (fn [_params]
           (re-frame/dispatch [::events/clear-current-entity entity-type])
           (re-frame/dispatch [::collab-ws/unsubscribe-form-ws [(:plural-key metadata)]])
           (re-frame/dispatch [::forms/reset-form-state false entity-type form-id []]))
   :identity :parameters})

(re-frame/reg-sub
  ::dirty-fields-override
  (fn []
    [(re-frame/subscribe [::f3.forms/dirty-fields form-id])
     (re-frame/subscribe [::f3.forms/form-state :step-params-instance])])
  (fn [[main-dirty-fields params-form-state]]
    (let [params-dirty (seq (filter :dirty?
                                    (vals (:fields params-form-state))))]
      (concat main-dirty-fields
              (if params-dirty
                [{:id :params}]
                [])))))

(defn run-button [{:keys [dirty-fields base-entity main-ref] :as form-props}]
  (let [dirty? (seq @dirty-fields)
        disabled? (or dirty?
                      (not (permissions/has-permission? run-permission)))
        test-type (get-in base-entity [:qtest_design :test_type])
        automated? (test-type/is-automated? test-type)
        xbot? (test-type/is-xbot? test-type)]
    (if (and automated? (not xbot?))
      [buttons/button
       {:secondary? true
        :disabled? disabled?
        :on-click (fn [e]
                    (when (footer/validate-fields! form-props)
                      (re-frame/dispatch [::instance-events/run-test base-entity {:run_as_manual "true"}])))
        :size "medium"
        :text (get-translation "instance.button.run-as-manual" "Run as manual")}]
      [buttons/button
       {:primary? true
        :disabled? disabled?
        :on-click (fn [e]
                    (when (footer/validate-fields! form-props)
                      (re-frame/dispatch [::instance-events/run-test base-entity])))
        :size "medium"
        :text (get-translation "instance.button.run" "Run")}])))

(defn- additional-params-validation
  [save-form! form-props options]
  (when (step-parameters/steps-pre-validation! form-props)
    (save-form! form-props options)))

(defn save-and-run-button [{:keys [dirty-fields] :as form-props} save-form!]
  [buttons/button
   {:primary? true
    :size "medium"
    :on-click (fn [e]
                (mixpanel/track "Form Actions" {"Action" "Save and Run Instance"})
                (save-form! form-props {:save-and-run? true}))
    :text (get-translation "instance.button.save-and-run" "Save and Run")}])

(defn instance-footer-buttons
  [{:keys [dirty-fields base-entity] :as form-props} save-form!]
  (let [dirty? (seq @dirty-fields)
        ;; Wrap with additional mandatory validation for step params
        save-form! (partial additional-params-validation save-form!)]
    [:div.m-button-group
     [footer/standard-cancel-button form-props]
     [footer/standard-save-button form-props save-form!]
     ;; TODO: save and run as manual ?
     (when-not (test-type/is-automated? (get-in base-entity [:qtest_design :test_type]))
       (if dirty?
         [save-and-run-button form-props save-form!]
         [run-button form-props]))]))

(defn build-tabs
  []
  [(f3.entity-form/general-entity-tab)
   (traceability/build-traceability-tab)
   (f3.entity-form/history-tab)])

(defn- format-instance-name
  [instance]
  (str (f3.forms/entity->display-name entity-type) " of "
       (f3.forms/entity->display-name :test) " #" (:display_id (:qtest_design instance))))

(defn main [new?]
  (let [route @(re-frame/subscribe [::router/current-route])
        testset @(re-frame/subscribe [::forms/base-entity :testset])
        instance @(re-frame/subscribe [::forms/base-entity entity-type])
        test (:qtest_design instance)]
    [:<>
     (when (rewind-run/show-rewind-run?)
       [rewind-run/rewind-run-modal])

     [f3.entity-form/entity-form
      {:new? new?
       :popup-menu (instance-menu)
       :data-entity-type :testset
       :state-key :instances-state
       :entity-type entity-type
       :form-id form-id
       :entity-name-renderer (fn [form-props]
                               [:span.entity-name
                                (format-instance-name (:base-entity form-props))])
       :dirty-fields (re-frame/subscribe [::dirty-fields-override])
       :buttons-override instance-footer-buttons
       :on-save (partial-dispatch [::instance-events/save-instance (:id instance) (:id testset)])
       :on-cancel (partial-dispatch [::instance-events/reset-instance-form new?])
       ;; We will render last breadcrumb ourselves here
       :last-breadcrumb-fn (fn [_props]
                             (if test
                               (str (format-instance-name instance) " | " (:name (:qtest_design instance)))
                               (str "Loading")))
       :path-params {:set_id (:id testset)}
       :breadcrumbs [{:href (broutes/get-url-view "suites#edit" {:id (:id testset)})
                      :label (str (f3.forms/entity->display-name :testset) " #" (:display_id testset)
                                  ": " (:name testset))}]
       :instance-section linked-runs-section
       :additional-header-buttons run-button
       :header-tabs (build-tabs)
       :edit-permissions? (permissions/has-permission? edit-permission)
       :field-edit-permissions? {:name false}
       :customization-permissions? (permissions/has-permission? "customization")
       :general-form-inner-tabs {:edit #{:attachments}}
       :default-active-sub-tab :attachments}]]))
